import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppServices } from "../../../../hook/services";
import { useUserInfo } from "../../../../context/user";
import { Toast } from "../../../Toast/Toast";
import { generateRandomID } from "../../../../utils/generateRandomId";
import toast from "react-hot-toast";

const options = [
  { label: "Less than 10", value: "less-than-10" },
  { label: "11–100", value: "11-100" },
  { label: "101 or more", value: "101-or-more" },
];

const ScaleYourAISolutions = ({ type, inputs, setInputs, onNext, onBack }) => {
  const handleFormInputsChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onNext();
  };

  // const getting_whitelable_domain = async () => {
  //   const currentURL = window.location.href;
  //   const urlObject = new URL(currentURL);
  //   const domain = urlObject.hostname;
  //   const payload = {
  //     domain: domain,
  //   };
  //   const { response } = await Service.agency.getwhitelabel({
  //     payload: payload,
  //   });
  //   if (response) {
  //     setAgencyId(response.data?._id);
  //     setPlanId(response.data?.plan_id);
  //   }
  // };

  // useEffect(() => {
  //   getting_whitelable_domain();
  // }, [];

  return (
    <div>
      <div>
        <div className="container-main" style={{ background: "white" }}>
          <div className="container !mt-0" style={{ background: "white" }}>
            <div className="">
              <div className="text-center">
                <h1 className="text-[30px] font-medium">
                  Scale Your AI Solutions
                </h1>
                <p className="mt-4">
                  Help us understand your team's needs for optimal AI
                  integration
                </p>
              </div>

              <div className="mt-8 max-w-[420px] mx-auto">
                <form onSubmit={handleSubmit} className="loginForm">
                  <div className="mb-4">
                    <input
                      type="text"
                      name="name"
                      placeholder="Your Name"
                      value={inputs.name}
                      onChange={handleFormInputsChange}
                      className="w-full !py-3"
                    />
                  </div>

                  <div className="mb-4">
                    <input
                      type="text"
                      name="business_name"
                      placeholder="Business Name"
                      value={inputs.business_name}
                      onChange={handleFormInputsChange}
                      className="w-full !py-3"
                    />
                  </div>

                  <div className="mb-4">
                    <input
                      type="text"
                      name="phone_number"
                      placeholder="Mobile number (Optional)"
                      size="large"
                      value={inputs.phone_number}
                      onChange={handleFormInputsChange}
                      className="w-full !py-3"
                    />
                  </div>

                  <div className="mt-8" style={{ textAlign: "right" }}>
                    <button
                      style={{
                        width: "100%",
                        padding: "12px",
                        borderRadius: "5px",
                      }}
                      size="large"
                      type="submit"
                      disabled={!inputs.name || !inputs.business_name}
                      className={`${!inputs.name || !inputs.business_name
                        ? "!bg-[#F5F5F5] border !border-[#D9D9D9] !text-black"
                        : "bg-black text-white"
                        }`}
                    >
                      {"Next"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span
        onClick={onBack}
        className="text-[#757575] text-[12px] ml-8 cursor-pointer flex float-start"
      >
        ← Go back
      </span>
      <Toast
        duration={300}
        message={toast.message}
        subMessage={toast.subMessage ?? ""}
        type={toast.type}
        visible={toast.isVisible}
      />
    </div>
  );
};

export default ScaleYourAISolutions;
